import type { TOC } from '@ember/component/template-only';
import type VisitComposite from 'garaje/models/visit-composite';

import TimeCell from './time-cell';

interface SignInTimeCellSignature {
  Args: {
    row: VisitComposite;
  };
}

export default <template>
  <TimeCell @time={{@row.signInTime}} @locationTimezone={{@row.locationTimezone}} />
</template> satisfies TOC<SignInTimeCellSignature>;
